import { Redirect, Router } from "@reach/router"
import { usePublishingFeature } from "source/publishing"
import { WideLayout } from "source/shared/Layout"
import { SermonEpisodeLayout } from "source/shared/Layout"
import { Error404 } from "source/shared/Error404"
import { ChannelList } from "./ChannelList"
import { SeriesList } from "./SeriesList"
import { EpisodeList } from "./EpisodeList"
import { Series } from "./Series"
import { Channel } from "./Channel"
import { Episode } from "./Episode"

export function SermonChannels() {
  const enabled = usePublishingFeature("sermons")

  if (!enabled) return <Redirect to="/" />

  return (
    <WideLayout>
      <Router>
        <ChannelList path="/" />
        <Series path="/:channelId/series/:seriesId" />
        <SeriesList path="/:channelId/series" />
        <EpisodeList path="/:channelId/episodes" />
        <Channel path="/:channelId" />
        <Error404 path="*" />
      </Router>
    </WideLayout>
  )
}

export function SermonEpisodes() {
  const enabled = usePublishingFeature("sermons")

  if (!enabled) return <Redirect to="/" />

  return (
    <SermonEpisodeLayout>
      <Router className="d-f fd-c d-b@md">
        <Episode path="/:episodeId" />
        <Error404 path="*" />
      </Router>
    </SermonEpisodeLayout>
  )
}
